module.exports = __webpack_public_path__ + "static/media/fireworks.7f0976c7.gif";